import { Loader2 } from "lucide-react";
import { useTran } from "@/hooks";

const RefreshingBadge = () => {
  const { t } = useTran();
  return (
    <div className="pointer-events-none absolute right-2 top-2 z-10 flex items-center gap-1.5 rounded-full bg-background px-2 py-1 text-[11px] text-muted-foreground shadow ring-1 ring-border">
      <Loader2 className="h-3 w-3 animate-spin text-primary" />
      {t("Refreshing...")}
    </div>
  );
};

export default RefreshingBadge;
